// Tài nguyên (code) và cờ (flag) của backend trong user.access: { [code]: { [flag]: boolean } }
export const PERMISSION = {
  PACKAGING_MASTER: 'packaging.master',
  PACKAGING_PRODUCTION_REQUEST: 'packaging.production_request',
  PACKAGING_PRODUCTION_PALLET: 'packaging.production_pallet',
  PACKAGING_PRODUCTION_CARTON: 'packaging.production_carton',
  PACKAGING_PRODUCTION_BAG: 'packaging.production_bag',
  PACKAGING_WAREHOUSE: 'packaging.warehouse',
  PACKAGING_STOCK_RECEIPT: 'packaging.stock_receipt',
  PRODUCT_DEFINITIONS: 'product_definitions',
  USERS: 'users',
  DESIGNS: 'designs',
  ORDERS: 'orders',
  SALE_PRODUCTS: 'sale_products',
  ANALYTICS: 'analytics',
  CATALOG: 'catalog',
  CUSTOMERS: 'customers',
};

// view = đọc; create, edit = ghi; edit_status = chỉ đổi trạng thái đóng gói (pallet, thùng, túi);
// delete = xóa; confirm, refund, pm_update, view_admin_items là thao tác riêng
export const PERMISSION_FLAG = {
  VIEW: 'view',
  CREATE: 'create',
  EDIT: 'edit',
  EDIT_STATUS: 'edit_status',
  DELETE: 'delete',
  CONFIRM: 'confirm',
  REFUND: 'refund',
  PM_UPDATE: 'pm_update',
  VIEW_ADMIN_ITEMS: 'view_admin_items',
};
